import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { CoachSettings } from "../interfaces";
import { SettingsServices } from "../services";

export const usePlayerSettings = (playerId: string | number | null | undefined) => {
  const { data: playerAppSettings } = useQuery({
    queryKey: ["playerAppSettings", playerId],
    queryFn: async () => {
      return SettingsServices.getAppSettingsByPlayerId(playerId!);
    },
    enabled: !!playerId,
    meta: { persist: true },
    staleTime: 1000 * 60, // 1 minute
    gcTime: 1000 * 60 * 60 * 13, // 13 hours
  });

  const hasSetting = useCallback(
    (setting: CoachSettings, defaultIfUndefined: boolean = false): boolean | undefined => {
      if (!playerAppSettings) return undefined;

      const settingStatus = playerAppSettings.settings?.find(s => s.appSettingId === setting)?.status;

      return settingStatus ? settingStatus === "ACTIVE" : defaultIfUndefined;
    },
    [playerAppSettings]
  );

  return { hasSetting };
};
